import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Http, Headers } from '@angular/http';
//import { HttpClientModule } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CoreService } from '../core/core.service';
import { MiscService } from './misc.service';
import { Main } from '../core/main.service';
import { EkubService } from '@app/ekub/ekub.service';

@Component({
  selector: 'cp-branch-add',
  templateUrl: './branch.add.component.html',
  styleUrls: ['./branch.add.component.scss']
})

export class BranchAddComponent {

  branch: any = {};
  isLoading: any;
  id: string;
  ekubId: string;
  message: string = 'Branch 1';
  branchForm!: FormGroup;
  config: any;
  operation: string;
  ekubMembers: any[];
  selectedMember: any;
  regions: any;

  error: string;
  userId: number = 1;
  ekubs: any = [];

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private api: MiscService, private ekubApi: EkubService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      this.getBranch();
    }
    this.operation = !this.id ? 'add' : 'update';
    this.regions = [
      { name: "Addis Ababa", value: "Addis Ababa" },
      { name: "Afar", value: "Afar" },
      { name: "Amhara", value: "Amhara" },
      { name: "Benishangul", value: "Benishangul-Gumuz" },
      { name: "Diredawa", value: "Dire Dawa" },
      { name: "Gambela", value: "Gambela" },
      { name: "Harari", value: "Harari" },
      { name: "Oromia", value: "Oromia" },
      { name: "Sidama", value: "Sidama" },
      { name: "Somali", value: "somali" },
      { name: "SNNP", value: "SNNP" },
      { name: "Tigray", value: "Tigray" },
    ];
  }

  get name() { return this.branchForm.get('name'); }
  get region() { return this.branchForm.get('region'); }
  get city() { return this.branchForm.get('city'); }
  get sub_city() { return this.branchForm.get('sub_city'); }
  get woreda_kebele() { return this.branchForm.get('woreda_kebele'); }
  get house_no() { return this.branchForm.get('house_no'); }
  get specific_location() { return this.branchForm.get('specific_location'); }
  get phone_number_1() { return this.branchForm.get('phone_number_1'); }
  get phone_number_2() { return this.branchForm.get('phone_number_2'); }
  get email() { return this.branchForm.get('email'); }
  get contact_person() { return this.branchForm.get('contact_person'); }
  get status() { return this.branchForm.get('status'); }
  get remark() { return this.branchForm.get('remark'); }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {

    this.branchForm = this.formBuilder.group({
      name: ['', [Validators.required,]],
      region: ['', [Validators.required]],
      city: ['', [Validators.required]],
      sub_city: ['', [Validators.required]],
      woreda_kebele: [''],
      house_no: ['', [Validators.required,]],
      phone_number_1: ['', Validators.required],
      phone_number_2: ['', Validators.required],
      specific_location: ['', Validators.required],
      email: ['', Validators.required],
      contact_person: ['', Validators.required],
      status: ['pending', Validators.required],
      remark: [''],
    });
  }

  getBranch() {
    debugger;
    this.api.getBranch(this.id).subscribe((res: any) => {
      debugger;
      this.branch = Object.assign(this.branch, res.data);
      var temp_branch = Object.assign(res.data);
      delete temp_branch.id;
      delete temp_branch.created_at;
      this.branchForm.setValue(temp_branch);

    });
  }

  addBranch() {
    debugger;
    this.isLoading = !this.isLoading;
    this.branch = this.branchForm.value;
    //var id = this.branch.id != null ? this.branch.id : null;
    this.api.createBranch(this.branch, this.id).subscribe((res: any) => {
      //this.api.createBranch({ branch: this.branch }, this.id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Branch successfully updated! ' : 'Branch  successfully added!', type: 'dark' });
      this.router.navigate(['/branches']);
    }, (err) => {
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update branch!' : 'Could not add branch!', type: 'danger' });
    });

  }

}
